import { computed } from '@ember/object';
import DateTime from '@square/dashboard-data/models/squareup/common/time/date-time';
import MoneyProto from '@square/dashboard-data/models/squareup/common/money-proto';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  money: attr(MoneyProto),
  taxOnFeeMoney: attr(MoneyProto),
  adjustedAt: attr(DateTime),
  totalAdjustmentMoney: computed('money', 'taxOnFeeMoney', function () {
    const total = this.money;
    if (this.taxOnFeeMoney) {
      return total.add(this.taxOnFeeMoney);
    }
    return total;
  })
});